import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/auth";
import LandingPage from "@/pages/LandingPage";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AppLayout from "@/components/AppLayout";
import Automations from "@/pages/Automations";
import Conversations from "@/pages/Conversations";
import Leads from "@/pages/Leads";
import Customers from "@/pages/Customers";
import Payments from "@/pages/Payments";
import Analytics from "@/pages/Analytics";
import Billing from "@/pages/Billing";
import Settings from "@/pages/Settings";
import PublicChat from "@/pages/PublicChat";
import SuperAdmin from "@/pages/SuperAdmin";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center"><div className="text-zinc-500 text-sm tracking-widest uppercase">Loading…</div></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#09090b", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" } }} />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/c/:slug" element={<PublicChat />} />
          <Route path="/app" element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route index element={<Navigate to="/app/automations" replace />} />
            <Route path="automations" element={<Automations />} />
            <Route path="conversations" element={<Conversations />} />
            <Route path="conversations/:sessionId" element={<Conversations />} />
            <Route path="leads" element={<Leads />} />
            <Route path="customers" element={<Customers />} />
            <Route path="payments" element={<Payments />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="billing" element={<Billing />} />
            <Route path="settings" element={<Settings />} />
            <Route path="admin" element={<SuperAdmin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
